import { map } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';

import { Maybe } from '@iss/libs/graphql';
import { MobileAuthService } from '@iss/libs/auth';

export const COOKIE_EMAIL_KEY = 'WO_COOKIE_EMAIL';
export const MOBILE_EMAIL_KEY = 'WO_MOBILE_EMAIL';

export const resolveAuthEmail: ResolveFn<Maybe<string>> = () => {
  const cookie = inject(CookieService);
  const mobile = inject(MobileAuthService);

  return mobile.retrieve(MOBILE_EMAIL_KEY).pipe(map(
    email => email || cookie.get(COOKIE_EMAIL_KEY) || undefined),
  );
};
